import { IndividualExtendedModel, CompanyExtendedModel, ClientStatusesEnum } from '@spa/api';
export class ClientHelper{

    static isClientVerified(client: IndividualExtendedModel | CompanyExtendedModel) {
        return client.status === ClientStatusesEnum.Verified
        || client.status === ClientStatusesEnum.Active
        || client.status === ClientStatusesEnum.Blocked
        || client.status === ClientStatusesEnum.Terminated;
    }
}
